import { Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
import { useTheme } from "@emotion/react";
import {
  GridRowModes,
  DataGrid,
  GridRowEditStopReasons,
  GridToolbar,
} from "@mui/x-data-grid";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const ValidityGrid = () => {
  const theme = useTheme();
  const { batchId } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [originalFeatures, setOriginalFeatures] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const animatedComponents = makeAnimated();
  const [featuresList, setFeaturesList] = useState([]);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const handleEditClick = (row) => {
    setSelectedRow(row);

    // pre-fill selected features
    const mappedFeatures = row.validityFeatures?.map(f => ({
      label: f.title,
      value: f._id,
    }));

    setSelectedFeatures(mappedFeatures);

    setOpen(true);
  };
  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const editDataInDb = async (data) => {
    const token = localStorage.getItem("token");
    const oldFeatureIds = originalFeatures[data.id] || [];
    const finalFeatureIds = data.features;
    const fullResponse = await fetch(
      `${process.env.REACT_APP_LIVE_URL}/adminSection/updateValidity`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: data?.id,
          name: data?.title,
          month: data?.month,
          salePrice: data?.salePrice,
          regularPrice: data?.regularPrice,
          isActive: data?.isActive,
          isRecommended: data?.isRecommended,
          features: finalFeatureIds,
        }),
      }
    );

    const responseJson = await fullResponse.json();

    if (responseJson.status === true) {
      toast.success("Validity Update Successfully");

      // update original snapshot
      setOriginalFeatures(prev => ({
        ...prev,
        [data.id]: finalFeatureIds
      }));

    } else {
      toast.error(responseJson.msg);
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(prev =>
      prev.map(row =>
        row.id === updatedRow.id ? updatedRow : row
      )
    );
    editDataInDb(updatedRow)
    //  console.log("65" , newRow);
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };


  const columns = [
    {
      field: "sno",
      headerName: "S NO",
      width: 65,
      align: "left",
      headerAlign: "left",
      editable: false,
      renderCell: (params) => <strong>{params.value}</strong>,
    },
    {
      field: "month",
      headerName: "Month",
      type: "number",
      width: 70,
      align: "left",
      headerAlign: "left",
      editable: true,
    },
    {
      field: "salePrice",
      headerName: "Sale Price",
      type: "number",
      width: 100,
      align: "left",
      headerAlign: "left",
      editable: true,
    },
    {
      field: "regularPrice",
      headerName: "Regular Price",
      type: "number",
      width: 110,
      align: "left",
      headerAlign: "left",
      editable: true,
    },
    {
      field: "title",
      headerName: "Title",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "features",
      headerName: "Features",
      type: "string",
      width: 400,
      align: "left",
      headerAlign: "left",
      editable: true,
    },
    {
      field: "isRecommended",
      headerName: "Recommend Status",
      type: "boolean",
      width: 200,
      align: "left",
      headerAlign: "left",
      editable: true,
      // renderCell: (params) => (
      //   <div style={{ color: params.value == true ? "green" : "red" }}>
      //     {params.value ? "Recommend" : "Not Recommened"}
      //   </div>
      // ),
    },
    {
      field: "isActive",
      headerName: "Status",
      type: "boolean",
      width: 100,
      align: "left",
      headerAlign: "left",
      editable: true,
      //  renderCell: (params) => (
      //    <div style={{ color: params.value == true ? "green" : "red" }}>
      //      {params.value ? "Active" : "inActive"}
      //    </div>
      //  ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <EditIcon
          style={{
            cursor: "pointer",
            color: "#1976d2",
          }}
          onClick={() => handleEditClick(params.row)}
        />
      ),
    }

    //  {
    //    field: "actions",
    //    type: "actions",
    //    headerName: "Actions",
    //    width: 100,
    //    cellClassName: "actions",
    //    getActions: ({ id }) => {
    //      const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
    //      const rowData = rows.find((item) => item.id === id);
    //      if (isInEditMode) {
    //        return [
    //          <GridActionsCellItem
    //            icon={<SaveIcon />}
    //            label="Save"
    //            sx={{
    //              color: "primary.main",
    //            }}
    //            onClick={handleSaveClick(id)}
    //          />,
    //          <GridActionsCellItem
    //            icon={<CancelIcon />}
    //            label="Cancel"
    //            className="textPrimary"
    //            onClick={handleCancelClick(id)}
    //            color="inherit"
    //          />,
    //        ];
    //      }

    //      return [
    //       // ( d?.access?.includes('all') ||  d?.accessForTab?.includes('read') ||  d?.accessForTab?.includes('readWrite')) ? 
    //       //  <GridActionsCellItem
    //       //    icon={<VisibilityOutlined />}
    //       //    label="Edit"
    //       //    className="textPrimary"
    //       //    // onClick={handleEditClick(id)}
    //       //    onClick={() => console.log('New Grid')}
    //       //    color="inherit"
    //       //  />
    //       //   : <></>,

    //        //     <GridActionsCellItem
    //        //     icon={<DeleteIcon style={{ color : 'red'}}/>}
    //        //     label="Delete"
    //        //     onClick={handleDeleteClick(id)}
    //        //     // onClick={ (id) => handleOpen(id)}

    //        //     color="inherit"
    //        //   />
    //      ];
    //    },
    //  },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");
    async function fetchValidity() {
      const fullResponse = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminSection/getValidityOfBatch/${batchId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseJson = await fullResponse.json();
      const formattedData = responseJson?.data.map((row, index) => ({
        ...row,
        sno: index + 1,
        title: row.name,
        features: row.validityFeatures?.map(f => f.title).join(", "),
      }));

      setRows(formattedData);
      const featureMap = {};
      responseJson?.data.forEach(row => {
        featureMap[row.id] = row.validityFeatures.map(f => f._id);
      });

      setOriginalFeatures(featureMap);
      setLoading(false);
    }
    async function fetchFeatures() {
      const token = localStorage.getItem("token");

      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminSection/getValidityFeatures?batchId=${batchId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      setFeaturesList(data?.data);
    }

    fetchFeatures();

    fetchValidity();
  }, []);
  //console.log(batchInfo);
  return (
    <>
      {loading ? (
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          {" "}
          <SyncLoader color={theme.palette.primary.mainTheme} loading={loading} size={20} />
        </Stack>
      ) : (
        <>
          <Typography variant="h3" mb={5} ml={3}>
            Validity Table of Batches
          </Typography>
          <DataGrid
            // sx={{ overflow: "auto" }}
            rowHeight={50}
            rows={rows}
            loading={loading}
            columns={columns}
            editMode="cell"
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 15,
                },
              },
            }}
            pageSizeOptions={[15, 25, 50]}
            slots={{
              //   toolbar: EditToolbar,
              toolbar: GridToolbar,
            }}
            slotProps={{
              toolbar: { setRows, setRowModesModel, showQuickFilter: true },
            }}
          />
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth="md"
            scroll="paper"
          >
            <DialogTitle>Edit Validity</DialogTitle>

            <DialogContent>
              <Stack spacing={2}>

                {/* PRICE ROW */}
                <Stack direction="row" spacing={2}>
                  <TextField
                    label="Regular Price"
                    fullWidth
                    value={selectedRow?.regularPrice || ""}
                    onChange={(e) =>
                      setSelectedRow({ ...selectedRow, regularPrice: e.target.value })
                    }
                  />

                  <TextField
                    label="Sale Price"
                    fullWidth
                    value={selectedRow?.salePrice || ""}
                    onChange={(e) =>
                      setSelectedRow({ ...selectedRow, salePrice: e.target.value })
                    }
                  />
                </Stack>

                {/* NAME */}
                <TextField
                  label="Name"
                  fullWidth
                  margin="dense"
                  value={selectedRow?.title || ""}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, title: e.target.value })
                  }
                />

                {/* MONTH */}
                <TextField
                  label="Month"
                  fullWidth
                  margin="dense"
                  value={selectedRow?.month || ""}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, month: e.target.value })
                  }
                />

                {/* FEATURES */}
                <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 2 }}>
                  <Typography sx={{ minWidth: "140px" }}>
                    Select Features
                  </Typography>

                  <Stack sx={{ width: "100%" }}>
                    <Select
                      isMulti
                      components={animatedComponents}
                      options={featuresList}
                      value={selectedFeatures}
                      onChange={(data) => setSelectedFeatures(data)}
                    />
                  </Stack>
                </Stack>

                {/* STATUS */}
                <TextField
                  select
                  label="Status"
                  fullWidth
                  margin="dense"
                  value={selectedRow?.isActive}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, isActive: e.target.value })
                  }
                >
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </TextField>

                {/* VALIDITY FOR */}
                <TextField
                  select
                  label="Validity For"
                  fullWidth
                  margin="dense"
                  value={selectedRow?.usedFor || 1}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, usedFor: e.target.value })
                  }
                >
                  <MenuItem value={1}>Live</MenuItem>
                  <MenuItem value={2}>Recorded</MenuItem>
                </TextField>

                {/* RECOMMENDED */}
                <TextField
                  select
                  label="Recommended Status"
                  fullWidth
                  margin="dense"
                  value={selectedRow?.isRecommended}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setSelectedRow({ ...selectedRow, isRecommended: e.target.value })
                  }
                >
                  <MenuItem value={true}>Recommended</MenuItem>
                  <MenuItem value={false}>Not Recommended</MenuItem>
                </TextField>
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setOpen(false)}>Cancel</Button>
              <Button
                variant="contained"
                onClick={() => {
                  const updatedRow = {
                    ...selectedRow,
                    month: Number(selectedRow.month),
                    salePrice: Number(selectedRow.salePrice),
                    regularPrice: Number(selectedRow.regularPrice),
                    isActive: selectedRow.isActive === true || selectedRow.isActive === "true",
                    isRecommended:
                      selectedRow.isRecommended === true || selectedRow.isRecommended === "true",

                    title: selectedRow.title,
                    features: selectedFeatures.map((f) => f.value),
                  };

                  processRowUpdate(updatedRow);
                  setOpen(false);
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
          <ToastContainer
            position="bottom-center"
            autoClose={1000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </>
      )}
    </>
  );
};

export default ValidityGrid;
